/**
 * BETA — fournisseur portail stubs (pharmacy demo never hits these, but
 * routes must respond so background polls don't 404).
 */
const empty = () => ({ data: [], total: 0 });
const success = () => ({ success: true });

export function register(route) {
  route("GET", "/fournisseur-portail/dashboard", () => ({
    ca_30j: 0,
    nb_clients: 0,
    nb_commandes: 0,
    message: "Portail fournisseur — non disponible en mode pharmacie démo",
  }));
  route("GET", "/fournisseur-portail/notifs", empty);
  route("PATCH", "/fournisseur-portail/notifs/lue", success);
  route("GET", "/fournisseur-portail/clients", empty);
  route("GET", "/fournisseur-portail/clients/pending", empty);
  route("POST", "/fournisseur-portail/clients/request", success);
  route("GET", "/fournisseur-portail/catalogue", empty);
  route("POST", "/fournisseur-portail/catalogue", success);
  route("DELETE", "/fournisseur-portail/catalogue/:cid", success);
  route("GET", "/fournisseur-portail/pre-commandes", empty);
  route("POST", "/fournisseur-portail/pre-commandes/:id/respond", success);
  route("GET", "/fournisseur-portail/pre-commandes/:pcId/offre-existante", () => ({ found: false }));
  route("POST", "/fournisseur-portail/pre-commandes/:pcId/offre", success);
}
